import { Component } from 'solid-js';
import { Link, MetaProvider } from "@solidjs/meta";
import './oss-notice-page.scss';
import { OSSNoticeHTMLProperties } from './oss-notice-page';

export const OSSNoticeHTML: Component = (properties) => {
    const {
    } = properties as OSSNoticeHTMLProperties

    return (
        <MetaProvider>
            <Link rel="canonical" href="https://www.microsoftcasualgames.com/oss-notice" />
            <div class="oss-notice-page">
                <div class="oss-notice-content">

                    <h1>NOTICES AND INFORMATION</h1>
                    <p><strong>Do Not Translate or Localize</strong></p>
                    <p>
                        This software incorporates material from third parties.
                        Microsoft makes certain open source code available at <a href="https://3rdpartysource.microsoft.com">https://3rdpartysource.microsoft.com</a>,
                        or you may send a check or money order for US $5.00, including the product name,
                        the open source component name, platform, and version number, to:
                    </p>
                    <address>
                        Source Code Compliance Team<br />
                        Microsoft Corporation<br />
                        One Microsoft Way<br />
                        Redmond, WA 98052<br />
                        USA
                    </address>
                    <p>
                        Notwithstanding any other terms, you may reverse engineer this software to the extent
                        required to debug changes to any libraries licensed under the GNU Lesser General Public License.
                    </p>
                    <ol>
                        <li>
                            <details>
                                <summary>
                                    tslib 2.7.0 - 0BSD
                                </summary>
                                <p><a href="https://www.typescriptlang.org/">https://www.typescriptlang.org/</a></p>
                                <ul><li>Copyright (c) Microsoft Corporation</li></ul>
                                <pre>
                                    Copyright (c) Microsoft Corporation.

                                    Permission to use, copy, modify, and/or distribute this software for any
                                    purpose with or without fee is hereby granted.

                                    THE SOFTWARE IS PROVIDED &quot;AS IS&quot; AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
                                    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
                                    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
                                    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
                                    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
                                    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
                                    PERFORMANCE OF THIS SOFTWARE.
                                </pre>
                            </details>
                        </li>
                        <li>
                            <details>
                                <summary>
                                    aria-query 5.3.0 - Apache-2.0
                                </summary>
                                <p><a href="https://github.com/A11yance/aria-query#readme">https://github.com/A11yance/aria-query#readme</a></p>
                                <ul><li>Copyright 2020 A11yance</li>
                                    <li>Copyright (c) 2021 A11yance</li>
                                    <li>Copyright year (2020) for A11yance</li></ul>
                                <pre>
                                    Apache License
                                    Version 2.0, January 2004
                                    http://www.apache.org/licenses/

                                    TERMS AND CONDITIONS FOR USE, REPRODUCTION, AND DISTRIBUTION

                                    1. Definitions.

                                    &quot;License&quot; shall mean the terms and conditions for use, reproduction,
                                    and distribution as defined by Sections 1 through 9 of this document.

                                    &quot;Licensor&quot; shall mean the copyright owner or entity authorized by
                                    the copyright owner that is granting the License.

                                    &quot;Legal Entity&quot; shall mean the union of the acting entity and all
                                    other entities that control, are controlled by, or are under common
                                    control with that entity. For the purposes of this definition,
                                    &quot;control&quot; means (i) the power, direct or indirect, to cause the
                                    direction or management of such entity, whether by contract or
                                    otherwise, or (ii) ownership of fifty percent (50%) or more of the
                                    outstanding shares, or (iii) beneficial ownership of such entity.

                                    &quot;You&quot; (or &quot;Your&quot;) shall mean an individual or Legal Entity
                                    exercising permissions granted by this License.

                                    &quot;Source&quot; form shall mean the preferred form for making modifications,
                                    including but not limited to software source code, documentation
                                    source, and configuration files.

                                    &quot;Object&quot; form shall mean any form resulting from mechanical
                                    transformation or translation of a Source form, including but
                                    not limited to compiled object code, generated documentation,
                                    and conversions to other media types.

                                    &quot;Work&quot; shall mean the work of authorship, whether in Source or
                                    Object form, made available under the License, as indicated by a
                                    copyright notice that is included in or attached to the work
                                    (an example is provided in the Appendix below).

                                    &quot;Derivative Works&quot; shall mean any work, whether in Source or Object
                                    form, that is based on (or derived from) the Work and for which the
                                    editorial revisions, annotations, elaborations, or other modifications
                                    represent, as a whole, an original work of authorship. For the purposes
                                    of this License, Derivative Works shall not include works that remain
                                    separable from, or merely link (or bind by name) to the interfaces of,
                                    the Work and Derivative Works thereof.

                                    &quot;Contribution&quot; shall mean any work of authorship, including
                                    the original version of the Work and any modifications or additions
                                    to that Work or Derivative Works thereof, that is intentionally
                                    submitted to Licensor for inclusion in the Work by the copyright owner
                                    or by an individual or Legal Entity authorized to submit on behalf of
                                    the copyright owner. For the purposes of this definition, &quot;submitted&quot;
                                    means any form of electronic, verbal, or written communication sent
                                    to the Licensor or its representatives, including but not limited to
                                    communication on electronic mailing lists, source code control systems,
                                    and issue tracking systems that are managed by, or on behalf of, the
                                    Licensor for the purpose of discussing and improving the Work, but
                                    excluding communication that is conspicuously marked or otherwise
                                    designated in writing by the copyright owner as &quot;Not a Contribution.&quot;

                                    &quot;Contributor&quot; shall mean Licensor and any individual or Legal Entity
                                    on behalf of whom a Contribution has been received by Licensor and
                                    subsequently incorporated within the Work.

                                    2. Grant of Copyright License. Subject to the terms and conditions of
                                    this License, each Contributor hereby grants to You a perpetual,
                                    worldwide, non-exclusive, no-charge, royalty-free, irrevocable
                                    copyright license to reproduce, prepare Derivative Works of,
                                    publicly display, publicly perform, sublicense, and distribute the
                                    Work and such Derivative Works in Source or Object form.

                                    3. Grant of Patent License. Subject to the terms and conditions of
                                    this License, each Contributor hereby grants to You a perpetual,
                                    worldwide, non-exclusive, no-charge, royalty-free, irrevocable
                                    (except as stated in this section) patent license to make, have made,
                                    use, offer to sell, sell, import, and otherwise transfer the Work,
                                    where such license applies only to those patent claims licensable
                                    by such Contributor that are necessarily infringed by their
                                    Contribution(s) alone or by combination of their Contribution(s)
                                    with the Work to which such Contribution(s) was submitted. If You
                                    institute patent litigation against any entity (including a
                                    cross-claim or counterclaim in a lawsuit) alleging that the Work
                                    or a Contribution incorporated within the Work constitutes direct
                                    or contributory patent infringement, then any patent licenses
                                    granted to You under this License for that Work shall terminate
                                    as of the date such litigation is filed.

                                    4. Redistribution. You may reproduce and distribute copies of the
                                    Work or Derivative Works thereof in any medium, with or without
                                    modifications, and in Source or Object form, provided that You
                                    meet the following conditions:

                                    (a) You must give any other recipients of the Work or
                                    Derivative Works a copy of this License; and

                                    (b) You must cause any modified files to carry prominent notices
                                    stating that You changed the files; and

                                    (c) You must retain, in the Source form of any Derivative Works
                                    that You distribute, all copyright, patent, trademark, and
                                    attribution notices from the Source form of the Work,
                                    excluding those notices that do not pertain to any part of
                                    the Derivative Works; and

                                    (d) If the Work includes a &quot;NOTICE&quot; text file as part of its
                                    distribution, then any Derivative Works that You distribute must
                                    include a readable copy of the attribution notices contained
                                    within such NOTICE file, excluding those notices that do not
                                    pertain to any part of the Derivative Works, in at least one
                                    of the following places: within a NOTICE text file distributed
                                    as part of the Derivative Works; within the Source form or
                                    documentation, if provided along with the Derivative Works; or,
                                    within a display generated by the Derivative Works, if and
                                    wherever such third-party notices normally appear. The contents
                                    of the NOTICE file are for informational purposes only and
                                    do not modify the License. You may add Your own attribution
                                    notices within Derivative Works that You distribute, alongside
                                    or as an addendum to the NOTICE text from the Work, provided
                                    that such additional attribution notices cannot be construed
                                    as modifying the License.

                                    You may add Your own copyright statement to Your modifications and
                                    may provide additional or different license terms and conditions
                                    for use, reproduction, or distribution of Your modifications, or
                                    for any such Derivative Works as a whole, provided Your use,
                                    reproduction, and distribution of the Work otherwise complies with
                                    the conditions stated in this License.

                                    5. Submission of Contributions. Unless You explicitly state otherwise,
                                    any Contribution intentionally submitted for inclusion in the Work
                                    by You to the Licensor shall be under the terms and conditions of
                                    this License, without any additional terms or conditions.
                                    Notwithstanding the above, nothing herein shall supersede or modify
                                    the terms of any separate license agreement you may have executed
                                    with Licensor regarding such Contributions.

                                    6. Trademarks. This License does not grant permission to use the trade
                                    names, trademarks, service marks, or product names of the Licensor,
                                    except as required for reasonable and customary use in describing the
                                    origin of the Work and reproducing the content of the NOTICE file.

                                    7. Disclaimer of Warranty. Unless required by applicable law or
                                    agreed to in writing, Licensor provides the Work (and each
                                    Contributor provides its Contributions) on an &quot;AS IS&quot; BASIS,
                                    WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or
                                    implied, including, without limitation, any warranties or conditions
                                    of TITLE, NON-INFRINGEMENT, MERCHANTABILITY, or FITNESS FOR A
                                    PARTICULAR PURPOSE. You are solely responsible for determining the
                                    appropriateness of using or redistributing the Work and assume any
                                    risks associated with Your exercise of permissions under this License.

                                    8. Limitation of Liability. In no event and under no legal theory,
                                    whether in tort (including negligence), contract, or otherwise,
                                    unless required by applicable law (such as deliberate and grossly
                                    negligent acts) or agreed to in writing, shall any Contributor be
                                    liable to You for damages, including any direct, indirect, special,
                                    incidental, or consequential damages of any character arising as a
                                    result of this License or out of the use or inability to use the
                                    Work (including but not limited to damages for loss of goodwill,
                                    work stoppage, computer failure or malfunction, or any and all
                                    other commercial damages or losses), even if such Contributor
                                    has been advised of the possibility of such damages.

                                    9. Accepting Warranty or Additional Liability. While redistributing
                                    the Work or Derivative Works thereof, You may choose to offer,
                                    and charge a fee for, acceptance of support, warranty, indemnity,
                                    or other liability obligations and/or rights consistent with this
                                    License. However, in accepting such obligations, You may act only
                                    on Your own behalf and on Your sole responsibility, not on behalf
                                    of any other Contributor, and only if You agree to indemnify,
                                    defend, and hold each Contributor harmless for any liability
                                    incurred by, or claims asserted against, such Contributor by reason
                                    of your accepting any such warranty or additional liability.

                                    END OF TERMS AND CONDITIONS

                                    APPENDIX: How to apply the Apache License to your work.

                                    To apply the Apache License to your work, attach the following
                                    boilerplate notice, with the fields enclosed by brackets &quot;{ }&quot;
                                    replaced with your own identifying information. (Don&#39;t include
                                    the brackets!)  The text should be enclosed in the appropriate
                                    comment syntax for the file format. We also recommend that a
                                    file or class name and description of purpose be included on the
                                    same &quot;printed page&quot; as the copyright notice for easier
                                    identification within third-party archives.

                                    Copyright 2020 A11yance

                                    Licensed under the Apache License, Version 2.0 (the &quot;License&quot;);
                                    you may not use this file except in compliance with the License.
                                    You may obtain a copy of the License at

                                    http://www.apache.org/licenses/LICENSE-2.0

                                    Unless required by applicable law or agreed to in writing, software
                                    distributed under the License is distributed on an &quot;AS IS&quot; BASIS,
                                    WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
                                    See the License for the specific language governing permissions and
                                    limitations under the License.

                                </pre>
                            </details>
                        </li>
                        <li>
                            <details>
                                <summary>
                                    @adobe/css-tools 4.4.0 - MIT
                                </summary>
                                <p><a href="https://github.com/adobe/css-tools#readme">https://github.com/adobe/css-tools#readme</a></p>
                                <ul><li>Copyright (c) 2012 TJ Holowaychuk &lt;tj@vision-media.ca&gt;</li>
                                    <li>Copyright (c) 2022 Jean-Philippe Zolesio &lt;holblin@gmail.com&gt;</li></ul>
                                <pre>
                                    (The MIT License)

                                    Copyright (c) 2012 TJ Holowaychuk &lt;tj@vision-media.ca&gt;
                                    Copyright (c) 2022 Jean-Philippe Zolesio &lt;holblin@gmail.com&gt;

                                    Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the &#39;Software&#39;), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:

                                    The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

                                    THE SOFTWARE IS PROVIDED &#39;AS IS&#39;, WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

                                </pre>
                            </details>
                        </li>
                        <li>
                            <details>
                                <summary>
                                    @esbuild/win32-x64 0.19.12 - MIT
                                </summary>
                                <p><a href="https://github.com/evanw/esbuild#readme">https://github.com/evanw/esbuild#readme</a></p>

                                <pre>
                                    MIT License

                                    Copyright (c) &lt;year&gt; &lt;copyright holders&gt;

                                    Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the &quot;Software&quot;), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:

                                    The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

                                    THE SOFTWARE IS PROVIDED &quot;AS IS&quot;, WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
                                </pre>
                            </details>
                        </li>
                        <li>
                            <details>
                                <summary>
                                    @microsoft/applicationinsights-analytics-js 3.1.2 - MIT
                                </summary>
                                <p><a href="https://github.com/microsoft/ApplicationInsights-JS#readme">https://github.com/microsoft/ApplicationInsights-JS#readme</a></p>
                                <ul><li>copyright Microsoft 2018</li>
                                    <li>Copyright (c) 2022 Nevware21</li>
                                    <li>Copyright (c) 2023 Nevware21</li>
                                    <li>Copyright (c) 2024 Nevware21</li>
                                    <li>Copyright (c) Microsoft Corporation</li>
                                    <li>Copyright (c) Microsoft and contributors</li></ul>
                                <pre>
                                    The MIT License (MIT)

                                    Copyright (c) Microsoft Corporation

                                    Permission is hereby granted, free of charge, to any person obtaining a copy
                                    of this software and associated documentation files (the &quot;Software&quot;), to deal
                                    in the Software without restriction, including without limitation the rights
                                    to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
                                    copies of the Software, and to permit persons to whom the Software is
                                    furnished to do so, subject to the following conditions:

                                    The above copyright notice and this permission notice shall be included in all
                                    copies or substantial portions of the Software.

                                    THE SOFTWARE IS PROVIDED &quot;AS IS&quot;, WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
                                    IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
                                    FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
                                    AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
                                    LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
                                    OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
                                    SOFTWARE.

                                </pre>
                            </details>
                        </li>
                        <li>
                            <details>
                                <summary>
                                    @microsoft/applicationinsights-cfgsync-js 3.1.2 - MIT
                                </summary>
                                <p><a href="https://github.com/microsoft/ApplicationInsights-JS#readme">https://github.com/microsoft/ApplicationInsights-JS#readme</a></p>
                                <ul><li>copyright Microsoft 2018</li>
                                    <li>Copyright (c) 2022 Nevware21</li>
                                    <li>Copyright (c) 2023 Nevware21</li>
                                    <li>Copyright (c) 2024 Nevware21</li>
                                    <li>Copyright (c) Microsoft Corporation</li>
                                    <li>Copyright (c) Microsoft and contributors</li></ul>
                                <pre>
                                    MIT License

                                    Copyright (c) &lt;year&gt; &lt;copyright holders&gt;

                                    Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the &quot;Software&quot;), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:

                                    The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

                                    THE SOFTWARE IS PROVIDED &quot;AS IS&quot;, WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
                                </pre>
                            </details>
                        </li>
                        <li>
                            <details>
                                <summary>
                                    @microsoft/applicationinsights-channel-js 3.1.2 - MIT
                                </summary>
                                <p><a href="https://github.com/microsoft/ApplicationInsights-JS#readme">https://github.com/microsoft/ApplicationInsights-JS#readme</a></p>
                                <ul><li>Copyright (c) 2022 Nevware21</li>
                                    <li>Copyright (c) 2023 Nevware21</li>
                                    <li>Copyright (c) 2024 Nevware21</li>
                                    <li>Copyright (c) Microsoft Corporation</li>
                                    <li>Copyright (c) Microsoft and contributors</li></ul>
                                <pre>
                                    The MIT License (MIT)

                                    Copyright (c) Microsoft Corporation

                                    Permission is hereby granted, free of charge, to any person obtaining a copy
                                    of this software and associated documentation files (the &quot;Software&quot;), to deal
                                    in the Software without restriction, including without limitation the rights
                                    to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
                                    copies of the Software, and to permit persons to whom the Software is
                                    furnished to do so, subject to the following conditions:

                                    The above copyright notice and this permission notice shall be included in all
                                    copies or substantial portions of the Software.

                                    THE SOFTWARE IS PROVIDED &quot;AS IS&quot;, WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
                                    IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
                                    FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
                                    AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
                                    LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
                                    OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
                                    SOFTWARE.

                                </pre>
                            </details>
                        </li>
                        <li>
                            <details>
                                <summary>
                                    @microsoft/applicationinsights-common 3.1.2 - MIT
                                </summary>
                                <p><a href="https://github.com/microsoft/ApplicationInsights-JS#readme">https://github.com/microsoft/ApplicationInsights-JS#readme</a></p>
                                <ul><li>Copyright (c) 2022 Nevware21</li>
                                    <li>Copyright (c) 2023 Nevware21</li>
                                    <li>Copyright (c) 2024 Nevware21</li>
                                    <li>Copyright (c) Microsoft Corporation</li>
                                    <li>Copyright (c) Microsoft and contributors</li></ul>
                                <pre>
                                    The MIT License (MIT)

                                    Copyright (c) Microsoft Corporation

                                    Permission is hereby granted, free of charge, to any person obtaining a copy
                                    of this software and associated documentation files (the &quot;Software&quot;), to deal
                                    in the Software without restriction, including without limitation the rights
                                    to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
                                    copies of the Software, and to permit persons to whom the Software is
                                    furnished to do so, subject to the following conditions:

                                    The above copyright notice and this permission notice shall be included in all
                                    copies or substantial portions of the Software.

                                    THE SOFTWARE IS PROVIDED &quot;AS IS&quot;, WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
                                    IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
                                    FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
                                    AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
                                    LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
                                    OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
                                    SOFTWARE.

                                </pre>
                            </details>
                        </li>
                        <li>
                            <details>
                                <summary>
                                    @microsoft/applicationinsights-core-js 3.1.2 - MIT
                                </summary>
                                <p><a href="https://github.com/microsoft/ApplicationInsights-JS#readme">https://github.com/microsoft/ApplicationInsights-JS#readme</a></p>
                                <ul><li>Copyright (c) 2022 Nevware21</li>
                                    <li>Copyright (c) 2023 Nevware21</li>
                                    <li>Copyright (c) 2024 Nevware21</li>
                                    <li>Copyright (c) Microsoft Corporation</li>
                                    <li>Copyright (c) Microsoft and contributors</li></ul>
                                <pre>
                                    The MIT License (MIT)

                                    Copyright (c) Microsoft Corporation

                                    Permission is hereby granted, free of charge, to any person obtaining a copy
                                    of this software and associated documentation files (the &quot;Software&quot;), to deal
                                    in the Software without restriction, including without limitation the rights
                                    to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
                                    copies of the Software, and to permit persons to whom the Software is
                                    furnished to do so, subject to the following conditions:

                                    The above copyright notice and this permission notice shall be included in all
                                    copies or substantial portions of the Software.

                                    THE SOFTWARE IS PROVIDED &quot;AS IS&quot;, WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
                                    IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
                                    FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
                                    AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
                                    LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
                                    OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
                                    SOFTWARE.

                                </pre>
                            </details>
                        </li>
                        <li>
                            <details>
                                <summary>
                                    @microsoft/applicationinsights-dependencies-js 3.1.2 - MIT
                                </summary>
                                <p><a href="https://github.com/microsoft/ApplicationInsights-JS#readme">https://github.com/microsoft/ApplicationInsights-JS#readme</a></p>
                                <ul><li>Copyright (c) 2022 Nevware21</li>
                                    <li>Copyright (c) 2023 Nevware21</li>
                                    <li>Copyright (c) 2024 Nevware21</li>
                                    <li>Copyright (c) Microsoft Corporation</li>
                                    <li>Copyright (c) Microsoft and contributors</li></ul>
                                <pre>
                                    The MIT License (MIT)

                                    Copyright (c) Microsoft Corporation

                                    Permission is hereby granted, free of charge, to any person obtaining a copy
                                    of this software and associated documentation files (the &quot;Software&quot;), to deal
                                    in the Software without restriction, including without limitation the rights
                                    to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
                                    copies of the Software, and to permit persons to whom the Software is
                                    furnished to do so, subject to the following conditions:

                                    The above copyright notice and this permission notice shall be included in all
                                    copies or substantial portions of the Software.

                                    THE SOFTWARE IS PROVIDED &quot;AS IS&quot;, WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
                                    IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
                                    FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
                                    AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
                                    LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
                                    OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
                                    SOFTWARE.

                                </pre>
                            </details>
                        </li>
                        <li>
                            <details>
                                <summary>
                                    @microsoft/applicationinsights-properties-js 3.1.2 - MIT
                                </summary>
                                <p><a href="https://github.com/microsoft/ApplicationInsights-JS#readme">https://github.com/microsoft/ApplicationInsights-JS#readme</a></p>
                                <ul><li>copyright Microsoft 2018</li>
                                    <li>Copyright (c) 2022 Nevware21</li>
                                    <li>Copyright (c) 2023 Nevware21</li>
                                    <li>Copyright (c) 2024 Nevware21</li>
                                    <li>Copyright (c) Microsoft Corporation</li>
                                    <li>Copyright (c) Microsoft and contributors</li></ul>
                                <pre>
                                    The MIT License (MIT)

                                    Copyright (c) Microsoft Corporation

                                    Permission is hereby granted, free of charge, to any person obtaining a copy
                                    of this software and associated documentation files (the &quot;Software&quot;), to deal
                                    in the Software without restriction, including without limitation the rights
                                    to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
                                    copies of the Software, and to permit persons to whom the Software is
                                    furnished to do so, subject to the following conditions:

                                    The above copyright notice and this permission notice shall be included in all
                                    copies or substantial portions of the Software.

                                    THE SOFTWARE IS PROVIDED &quot;AS IS&quot;, WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
                                    IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
                                    FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
                                    AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
                                    LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
                                    OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
                                    SOFTWARE.

                                </pre>
                            </details>
                        </li>
                        <li>
                            <details>
                                <summary>
                                    @microsoft/applicationinsights-shims 3.0.1 - MIT
                                </summary>
                                <p><a href="https://github.com/microsoft/ApplicationInsights-JS/tree/main/tools/shims">https://github.com/microsoft/ApplicationInsights-JS/tree/main/tools/shims</a></p>
                                <ul><li>Copyright (c) Microsoft Corporation</li>
                                    <li>Copyright (c) Microsoft and contributors</li></ul>
                                <pre>
                                    The MIT License (MIT)

                                    Copyright (c) Microsoft Corporation

                                    Permission is hereby granted, free of charge, to any person obtaining a copy
                                    of this software and associated documentation files (the &quot;Software&quot;), to deal
                                    in the Software without restriction, including without limitation the rights
                                    to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
                                    copies of the Software, and to permit persons to whom the Software is
                                    furnished to do so, subject to the following conditions:

                                    The above copyright notice and this permission notice shall be included in all
                                    copies or substantial portions of the Software.

                                    THE SOFTWARE IS PROVIDED &quot;AS IS&quot;, WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
                                    IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
                                    FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
                                    AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
                                    LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
                                    OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
                                    SOFTWARE.

                                </pre>
                            </details>
                        </li>
                        <li>
                            <details>
                                <summary>
                                    @microsoft/applicationinsights-web 3.1.2 - MIT
                                </summary>
                                <p><a href="https://github.com/microsoft/ApplicationInsights-JS#readme">https://github.com/microsoft/ApplicationInsights-JS#readme</a></p>
                                <ul><li>copyright Microsoft 2018</li>
                                    <li>Copyright (c) 2022 Nevware21</li>
                                    <li>Copyright (c) 2023 Nevware21</li>
                                    <li>Copyright (c) 2024 Nevware21</li>
                                    <li>Copyright (c) Microsoft Corporation</li>
                                    <li>Copyright (c) Microsoft and contributors</li></ul>
                                <pre>
                                    The MIT License (MIT)

                                    Copyright (c) Microsoft Corporation

                                    Permission is hereby granted, free of charge, to any person obtaining a copy
                                    of this software and associated documentation files (the &quot;Software&quot;), to deal
                                    in the Software without restriction, including without limitation the rights
                                    to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
                                    copies of the Software, and to permit persons to whom the Software is
                                    furnished to do so, subject to the following conditions:

                                    The above copyright notice and this permission notice shall be included in all
                                    copies or substantial portions of the Software.

                                    THE SOFTWARE IS PROVIDED &quot;AS IS&quot;, WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
                                    IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
                                    FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
                                    AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
                                    LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
                                    OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
                                    SOFTWARE.

                                </pre>
                            </details>
                        </li>
                        <li>
                            <details>
                                <summary>
                                    @microsoft/dynamicproto-js 2.0.3 - MIT
                                </summary>
                                <p><a href="https://github.com/microsoft/DynamicProto-JS#readme">https://github.com/microsoft/DynamicProto-JS#readme</a></p>
                                <ul><li>Copyright (c) 2022 Nevware21</li>
                                    <li>Copyright (c) Microsoft Corporation</li>
                                    <li>Copyright (c) Microsoft and contributors</li></ul>
                                <pre>
                                    The MIT License (MIT)

                                    Copyright (c) Microsoft Corporation

                                    Permission is hereby granted, free of charge, to any person obtaining a copy
                                    of this software and associated documentation files (the &quot;Software&quot;), to deal
                                    in the Software without restriction, including without limitation the rights
                                    to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
                                    copies of the Software, and to permit persons to whom the Software is
                                    furnished to do so, subject to the following conditions:

                                    The above copyright notice and this permission notice shall be included in all
                                    copies or substantial portions of the Software.

                                    THE SOFTWARE IS PROVIDED &quot;AS IS&quot;, WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
                                    IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
                                    FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
                                    AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
                                    LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
                                    OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
                                    SOFTWARE.

                                </pre>
                            </details>
                        </li>
                        <li>
                            <details>
                                <summary>
                                    @nevware21/ts-async 0.5.2 - MIT
                                </summary>
                                <p><a href="https://github.com/nevware21/ts-async">https://github.com/nevware21/ts-async</a></p>
                                <ul><li>Copyright (c) 2022 NevWare21 Solutions LLC</li>
                                    <li>Copyright (c) 2023 NevWare21 Solutions LLC</li>
                                    <li>Copyright (c) 2024 NevWare21 Solutions LLC</li>
                                    <li>Copyright (c) NevWare21 Solutions LLC and contributors</li></ul>
                                <pre>
                                    MIT License

                                    Copyright (c) 2022 NevWare21 Solutions LLC

                                    Permission is hereby granted, free of charge, to any person obtaining a copy
                                    of this software and associated documentation files (the &quot;Software&quot;), to deal
                                    in the Software without restriction, including without limitation the rights
                                    to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
                                    copies of the Software, and to permit persons to whom the Software is
                                    furnished to do so, subject to the following conditions:

                                    The above copyright notice and this permission notice shall be included in all
                                    copies or substantial portions of the Software.

                                    THE SOFTWARE IS PROVIDED &quot;AS IS&quot;, WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
                                    IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
                                    FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
                                    AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
                                    LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
                                    OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
                                    SOFTWARE.

                                </pre>
                            </details>
                        </li>
                        <li>
                            <details>
                                <summary>
                                    @nevware21/ts-utils 0.11.3 - MIT
                                </summary>
                                <p><a href="https://github.com/nevware21/ts-utils">https://github.com/nevware21/ts-utils</a></p>
                                <ul><li>Copyright (c) 2022 NevWare21 Solutions LLC</li>
                                    <li>Copyright (c) 2023 NevWare21 Solutions LLC</li>
                                    <li>Copyright (c) 2024 NevWare21 Solutions LLC</li>
                                    <li>Copyright (c) NevWare21 Solutions LLC and contributors</li></ul>
                                <pre>
                                    MIT License

                                    Copyright (c) 2022 NevWare21 Solutions LLC

                                    Permission is hereby granted, free of charge, to any person obtaining a copy
                                    of this software and associated documentation files (the &quot;Software&quot;), to deal
                                    in the Software without restriction, including without limitation the rights
                                    to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
                                    copies of the Software, and to permit persons to whom the Software is
                                    furnished to do so, subject to the following conditions:

                                    The above copyright notice and this permission notice shall be included in all
                                    copies or substantial portions of the Software.

                                    THE SOFTWARE IS PROVIDED &quot;AS IS&quot;, WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
                                    IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
                                    FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
                                    AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
                                    LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
                                    OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
                                    SOFTWARE.

                                </pre>
                            </details>
                        </li>
                        <li>
                            <details>
                                <summary>
                                    @rollup/rollup-win32-x64-msvc 4.21.1 - MIT
                                </summary>
                                <p><a href="https://rollupjs.org/">https://rollupjs.org/</a></p>

                                <pre>
                                    MIT License

                                    Copyright (c) &lt;year&gt; &lt;copyright holders&gt;

                                    Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the &quot;Software&quot;), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:

                                    The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

                                    THE SOFTWARE IS PROVIDED &quot;AS IS&quot;, WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
                                </pre>
                            </details>
                        </li>
                        <li>
                            <details>
                                <summary>
                                    @solidjs/router 0.13.6 - MIT
                                </summary>
                                <p><a href="https://github.com/solidjs/solid-router#readme">https://github.com/solidjs/solid-router#readme</a></p>
                                <ul><li>Copyright (c) 2020-2022 Ryan Carniato</li></ul>
                                <pre>
                                    MIT License

                                    Copyright (c) 2020-2022 Ryan Carniato

                                    Permission is hereby granted, free of charge, to any person obtaining a copy
                                    of this software and associated documentation files (the &quot;Software&quot;), to deal
                                    in the Software without restriction, including without limitation the rights
                                    to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
                                    copies of the Software, and to permit persons to whom the Software is
                                    furnished to do so, subject to the following conditions:

                                    The above copyright notice and this permission notice shall be included in all
                                    copies or substantial portions of the Software.

                                    THE SOFTWARE IS PROVIDED &quot;AS IS&quot;, WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
                                    IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
                                    FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
                                    AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
                                    LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
                                    OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
                                    SOFTWARE.
                                </pre>
                            </details>
                        </li>
                        <li>
                            <details>
                                <summary>
                                    @testing-library/jest-dom 6.5.0 - MIT
                                </summary>
                                <p><a href="https://github.com/testing-library/jest-dom#readme">https://github.com/testing-library/jest-dom#readme</a></p>
                                <ul><li>Copyright (c) 2017 Kent C. Dodds</li></ul>
                                <pre>
                                    The MIT License (MIT)
                                    Copyright (c) 2017 Kent C. Dodds

                                    Permission is hereby granted, free of charge, to any person obtaining a copy
                                    of this software and associated documentation files (the &quot;Software&quot;), to deal
                                    in the Software without restriction, including without limitation the rights
                                    to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
                                    copies of the Software, and to permit persons to whom the Software is
                                    furnished to do so, subject to the following conditions:

                                    The above copyright notice and this permission notice shall be included in all
                                    copies or substantial portions of the Software.

                                    THE SOFTWARE IS PROVIDED &quot;AS IS&quot;, WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
                                    IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
                                    FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
                                    AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
                                    LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
                                    OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
                                    SOFTWARE.

                                </pre>
                            </details>
                        </li>
                        <li>
                            <details>
                                <summary>
                                    ansi-styles 3.2.1 - MIT
                                </summary>
                                <p><a href="https://github.com/chalk/ansi-styles#readme">https://github.com/chalk/ansi-styles#readme</a></p>
                                <ul><li>Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)</li></ul>
                                <pre>
                                    MIT License

                                    Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)

                                    Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the &quot;Software&quot;), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:

                                    The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

                                    THE SOFTWARE IS PROVIDED &quot;AS IS&quot;, WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

                                </pre>
                            </details>
                        </li>
                        <li>
                            <details>
                                <summary>
                                    chalk 3.0.0 - MIT
                                </summary>
                                <p><a href="https://github.com/chalk/chalk#readme">https://github.com/chalk/chalk#readme</a></p>
                                <ul><li>Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)</li></ul>
                                <pre>
                                    MIT License

                                    Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)

                                    Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the &quot;Software&quot;), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:

                                    The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

                                    THE SOFTWARE IS PROVIDED &quot;AS IS&quot;, WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

                                </pre>
                            </details>
                        </li>
                        <li>
                            <details>
                                <summary>
                                    color-convert 1.9.3 - MIT
                                </summary>
                                <p><a href="https://github.com/Qix-/color-convert#readme">https://github.com/Qix-/color-convert#readme</a></p>
                                <ul><li>Copyright (c) 2011-2016, Heather Arthur and Josh Junon</li>
                                    <li>Copyright (c) 2011-2016 Heather Arthur &lt;fayearthur@gmail.com&gt;</li></ul>
                                <pre>
                                    Copyright (c) 2011-2016 Heather Arthur &lt;fayearthur@gmail.com&gt;

                                    Permission is hereby granted, free of charge, to any person obtaining
                                    a copy of this software and associated documentation files (the
                                    &quot;Software&quot;), to deal in the Software without restriction, including
                                    without limitation the rights to use, copy, modify, merge, publish,
                                    distribute, sublicense, and/or sell copies of the Software, and to
                                    permit persons to whom the Software is furnished to do so, subject to
                                    the following conditions:

                                    The above copyright notice and this permission notice shall be
                                    included in all copies or substantial portions of the Software.

                                    THE SOFTWARE IS PROVIDED &quot;AS IS&quot;, WITHOUT WARRANTY OF ANY KIND,
                                    EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
                                    MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
                                    NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
                                    LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
                                    OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
                                    WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.


                                </pre>
                            </details>
                        </li>
                        <li>
                            <details>
                                <summary>
                                    color-name 1.1.3 - MIT
                                </summary>
                                <p><a href="https://github.com/dfcreative/color-name">https://github.com/dfcreative/color-name</a></p>
                                <ul><li>Copyright (c) 2015 Dmitry Ivanov</li></ul>
                                <pre>
                                    The MIT License (MIT)
                                    Copyright (c) 2015 Dmitry Ivanov

                                    Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the &quot;Software&quot;), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:

                                    The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

                                    THE SOFTWARE IS PROVIDED &quot;AS IS&quot;, WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
                                </pre>
                            </details>
                        </li>
                        <li>
                            <details>
                                <summary>
                                    css.escape 1.5.1 - MIT
                                </summary>
                                <p><a href="https://mths.be/cssescape">https://mths.be/cssescape</a></p>
                                <ul><li>Copyright Mathias Bynens &lt;https://mathiasbynens.be/&gt;</li></ul>
                                <pre>
                                    Copyright Mathias Bynens &lt;https://mathiasbynens.be/&gt;

                                    Permission is hereby granted, free of charge, to any person obtaining
                                    a copy of this software and associated documentation files (the
                                    &quot;Software&quot;), to deal in the Software without restriction, including
                                    without limitation the rights to use, copy, modify, merge, publish,
                                    distribute, sublicense, and/or sell copies of the Software, and to
                                    permit persons to whom the Software is furnished to do so, subject to
                                    the following conditions:

                                    The above copyright notice and this permission notice shall be
                                    included in all copies or substantial portions of the Software.

                                    THE SOFTWARE IS PROVIDED &quot;AS IS&quot;, WITHOUT WARRANTY OF ANY KIND,
                                    EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
                                    MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
                                    NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
                                    LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
                                    OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
                                    WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

                                </pre>
                            </details>
                        </li>
                        <li>
                            <details>
                                <summary>
                                    csstype 3.1.3 - MIT
                                </summary>
                                <p><a href="https://github.com/frenic/csstype#readme">https://github.com/frenic/csstype#readme</a></p>
                                <ul><li>Copyright (c) 2017-2018 Fredrik Nicol</li></ul>
                                <pre>
                                    Copyright (c) 2017-2018 Fredrik Nicol

                                    Permission is hereby granted, free of charge, to any person obtaining a copy
                                    of this software and associated documentation files (the &quot;Software&quot;), to deal
                                    in the Software without restriction, including without limitation the rights
                                    to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
                                    copies of the Software, and to permit persons to whom the Software is
                                    furnished to do so, subject to the following conditions:

                                    The above copyright notice and this permission notice shall be included in all
                                    copies or substantial portions of the Software.

                                    THE SOFTWARE IS PROVIDED &quot;AS IS&quot;, WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
                                    IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
                                    FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
                                    AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
                                    LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
                                    OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
                                    SOFTWARE.

                                </pre>
                            </details>
                        </li>
                        <li>
                            <details>
                                <summary>
                                    dequal 2.0.3 - MIT
                                </summary>
                                <p><a href="https://github.com/lukeed/dequal#readme">https://github.com/lukeed/dequal#readme</a></p>
                                <ul><li>(c) Luke Edwards (https://lukeed.com)</li>
                                    <li>Copyright (c) Luke Edwards &lt;luke.edwards05@gmail.com&gt; (lukeed.com)</li></ul>
                                <pre>
                                    The MIT License (MIT)

                                    Copyright (c) Luke Edwards &lt;luke.edwards05@gmail.com&gt; (lukeed.com)

                                    Permission is hereby granted, free of charge, to any person obtaining a copy
                                    of this software and associated documentation files (the &quot;Software&quot;), to deal
                                    in the Software without restriction, including without limitation the rights
                                    to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
                                    copies of the Software, and to permit persons to whom the Software is
                                    furnished to do so, subject to the following conditions:

                                    The above copyright notice and this permission notice shall be included in
                                    all copies or substantial portions of the Software.

                                    THE SOFTWARE IS PROVIDED &quot;AS IS&quot;, WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
                                    IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
                                    FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
                                    AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
                                    LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
                                    OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
                                    THE SOFTWARE.

                                </pre>
                            </details>
                        </li>
                        <li>
                            <details>
                                <summary>
                                    dom-accessibility-api 0.6.3 - MIT
                                </summary>
                                <p><a href="https://github.com/eps1lon/dom-accessibility-api#readme">https://github.com/eps1lon/dom-accessibility-api#readme</a></p>
                                <ul><li>Copyright (c) 2020 Sebastian Silbermann</li></ul>
                                <pre>
                                    MIT License

                                    Copyright (c) 2020 Sebastian Silbermann

                                    Permission is hereby granted, free of charge, to any person obtaining a copy
                                    of this software and associated documentation files (the &quot;Software&quot;), to deal
                                    in the Software without restriction, including without limitation the rights
                                    to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
                                    copies of the Software, and to permit persons to whom the Software is
                                    furnished to do so, subject to the following conditions:

                                    The above copyright notice and this permission notice shall be included in all
                                    copies or substantial portions of the Software.

                                    THE SOFTWARE IS PROVIDED &quot;AS IS&quot;, WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
                                    IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
                                    FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
                                    AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
                                    LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
                                    OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
                                    SOFTWARE.

                                </pre>
                            </details>
                        </li>
                        <li>
                            <details>
                                <summary>
                                    has-flag 3.0.0 - MIT
                                </summary>
                                <p><a href="https://github.com/sindresorhus/has-flag#readme">https://github.com/sindresorhus/has-flag#readme</a></p>
                                <ul><li>(c) Sindre Sorhus (https://sindresorhus.com)</li>
                                    <li>Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)</li></ul>
                                <pre>
                                    MIT License

                                    Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)

                                    Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the &quot;Software&quot;), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:

                                    The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

                                    THE SOFTWARE IS PROVIDED &quot;AS IS&quot;, WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

                                </pre>
                            </details>
                        </li>
                        <li>
                            <details>
                                <summary>
                                    indent-string 4.0.0 - MIT
                                </summary>
                                <p><a href="https://github.com/sindresorhus/indent-string#readme">https://github.com/sindresorhus/indent-string#readme</a></p>
                                <ul><li>(c) Sindre Sorhus (https://sindresorhus.com)</li>
                                    <li>Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)</li></ul>
                                <pre>
                                    MIT License

                                    Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)

                                    Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the &quot;Software&quot;), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:

                                    The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

                                    THE SOFTWARE IS PROVIDED &quot;AS IS&quot;, WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

                                </pre>
                            </details>
                        </li>
                        <li>
                            <details>
                                <summary>
                                    lodash 4.17.21 - MIT
                                </summary>
                                <p><a href="https://lodash.com/">https://lodash.com/</a></p>
                                <ul><li>Copyright OpenJS Foundation and other contributors &lt;https://openjsf.org/&gt;</li>
                                    <li>Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters &amp; Editors</li>
                                    <li>copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters &amp; Editors &lt;http://underscorejs.org/&gt;</li></ul>
                                <pre>
                                    Copyright OpenJS Foundation and other contributors &lt;https://openjsf.org/&gt;

                                    Based on Underscore.js, copyright Jeremy Ashkenas,
                                    DocumentCloud and Investigative Reporters &amp; Editors &lt;http://underscorejs.org/&gt;

                                    This software consists of voluntary contributions made by many
                                    individuals. For exact contribution history, see the revision history
                                    available at https://github.com/lodash/lodash

                                    The following license applies to all parts of this software except as
                                    documented below:

                                    ====

                                    Permission is hereby granted, free of charge, to any person obtaining
                                    a copy of this software and associated documentation files (the
                                    &quot;Software&quot;), to deal in the Software without restriction, including
                                    without limitation the rights to use, copy, modify, merge, publish,
                                    distribute, sublicense, and/or sell copies of the Software, and to
                                    permit persons to whom the Software is furnished to do so, subject to
                                    the following conditions:

                                    The above copyright notice and this permission notice shall be
                                    included in all copies or substantial portions of the Software.

                                    THE SOFTWARE IS PROVIDED &quot;AS IS&quot;, WITHOUT WARRANTY OF ANY KIND,
                                    EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
                                    MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
                                    NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
                                    LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
                                    OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
                                    WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

                                    ====

                                    Copyright and related rights for sample code are waived via CC0. Sample
                                    code is defined as all source code displayed within the prose of the
                                    documentation.

                                    CC0: http://creativecommons.org/publicdomain/zero/1.0/

                                    ====

                                    Files located in the node_modules and vendor directories are externally
                                    maintained libraries used by this software which have their own
                                    licenses; we recommend you read them, as their terms may differ from the
                                    terms above.

                                </pre>
                            </details>
                        </li>
                        <li>
                            <details>
                                <summary>
                                    min-indent 1.0.1 - MIT
                                </summary>
                                <p><a href="https://github.com/thejameskyle/min-indent#readme">https://github.com/thejameskyle/min-indent#readme</a></p>
                                <ul><li>(c) James Kyle (https://thejameskyle.com)</li>
                                    <li>Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt;</li></ul>
                                <pre>

                                    The MIT License (MIT)

                                    Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com), James Kyle &lt;me@thejameskyle.com&gt; (thejameskyle.com)

                                    Permission is hereby granted, free of charge, to any person obtaining a copy
                                    of this software and associated documentation files (the &quot;Software&quot;), to deal
                                    in the Software without restriction, including without limitation the rights
                                    to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
                                    copies of the Software, and to permit persons to whom the Software is
                                    furnished to do so, subject to the following conditions:

                                    The above copyright notice and this permission notice shall be included in
                                    all copies or substantial portions of the Software.

                                    THE SOFTWARE IS PROVIDED &quot;AS IS&quot;, WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
                                    IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
                                    FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
                                    AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
                                    LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
                                    OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
                                    THE SOFTWARE.

                                </pre>
                            </details>
                        </li>
                        <li>
                            <details>
                                <summary>
                                    redent 3.0.0 - MIT
                                </summary>
                                <p><a href="https://github.com/sindresorhus/redent#readme">https://github.com/sindresorhus/redent#readme</a></p>
                                <ul><li>(c) Sindre Sorhus (https://sindresorhus.com)</li>
                                    <li>Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)</li></ul>
                                <pre>
                                    MIT License

                                    Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)

                                    Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the &quot;Software&quot;), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:

                                    The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

                                    THE SOFTWARE IS PROVIDED &quot;AS IS&quot;, WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

                                </pre>
                            </details>
                        </li>
                        <li>
                            <details>
                                <summary>
                                    seroval 1.1.1 - MIT
                                </summary>
                                <p><a href="https://github.com/lxsmnsyc/seroval/tree/main/packages/seroval">https://github.com/lxsmnsyc/seroval/tree/main/packages/seroval</a></p>
                                <ul><li>(c) lxsmnsyc (https://github.com/lxsmnsyc)</li>
                                    <li>Copyright (c) 2023 Alexis Munsayac &lt;alexis.munsayac@gmail.com&gt;</li></ul>
                                <pre>
                                    MIT License Copyright (c) 2023 Alexis Munsayac &lt;alexis.munsayac@gmail.com&gt;

                                    Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the &quot;Software&quot;), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:

                                    The above copyright notice and this permission notice (including the next paragraph) shall be included in all copies or substantial portions of the Software.

                                    THE SOFTWARE IS PROVIDED &quot;AS IS&quot;, WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
                                </pre>
                            </details>
                        </li>
                        <li>
                            <details>
                                <summary>
                                    seroval-plugins 1.1.1 - MIT
                                </summary>
                                <p><a href="https://github.com/lxsmnsyc/seroval/tree/main/packages/plugins">https://github.com/lxsmnsyc/seroval/tree/main/packages/plugins</a></p>
                                <ul><li>(c) lxsmnsyc (https://github.com/lxsmnsyc)</li>
                                    <li>Copyright (c) 2023 Alexis Munsayac &lt;alexis.munsayac@gmail.com&gt;</li></ul>
                                <pre>
                                    MIT License Copyright (c) 2023 Alexis Munsayac &lt;alexis.munsayac@gmail.com&gt;

                                    Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the &quot;Software&quot;), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:

                                    The above copyright notice and this permission notice (including the next paragraph) shall be included in all copies or substantial portions of the Software.

                                    THE SOFTWARE IS PROVIDED &quot;AS IS&quot;, WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
                                </pre>
                            </details>
                        </li>
                        <li>
                            <details>
                                <summary>
                                    solid-js 1.8.22 - MIT
                                </summary>
                                <p><a href="https://solidjs.com/">https://solidjs.com/</a></p>
                                <ul><li>Copyright (c) 2017 Adam Haile</li>
                                    <li>Copyright (c) 2016-2023 Ryan Carniato</li></ul>
                                <pre>
                                    MIT License

                                    Copyright (c) 2016-2023 Ryan Carniato

                                    Permission is hereby granted, free of charge, to any person obtaining a copy
                                    of this software and associated documentation files (the &quot;Software&quot;), to deal
                                    in the Software without restriction, including without limitation the rights
                                    to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
                                    copies of the Software, and to permit persons to whom the Software is
                                    furnished to do so, subject to the following conditions:

                                    The above copyright notice and this permission notice shall be included in all
                                    copies or substantial portions of the Software.

                                    THE SOFTWARE IS PROVIDED &quot;AS IS&quot;, WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
                                    IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
                                    FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
                                    AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
                                    LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
                                    OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
                                    SOFTWARE.

                                </pre>
                            </details>
                        </li>
                        <li>
                            <details>
                                <summary>
                                    strip-indent 3.0.0 - MIT
                                </summary>
                                <p><a href="https://github.com/sindresorhus/strip-indent#readme">https://github.com/sindresorhus/strip-indent#readme</a></p>
                                <ul><li>(c) Sindre Sorhus (https://sindresorhus.com)</li>
                                    <li>Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)</li></ul>
                                <pre>
                                    MIT License

                                    Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)

                                    Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the &quot;Software&quot;), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:

                                    The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

                                    THE SOFTWARE IS PROVIDED &quot;AS IS&quot;, WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

                                </pre>
                            </details>
                        </li>
                        <li>
                            <details>
                                <summary>
                                    supports-color 5.5.0 - MIT
                                </summary>
                                <p><a href="https://github.com/chalk/supports-color#readme">https://github.com/chalk/supports-color#readme</a></p>
                                <ul><li>Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)</li></ul>
                                <pre>
                                    MIT License

                                    Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)

                                    Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the &quot;Software&quot;), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:

                                    The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

                                    THE SOFTWARE IS PROVIDED &quot;AS IS&quot;, WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

                                </pre>
                            </details>
                        </li>
                    </ol>

                </div>
            </div>
        </MetaProvider>
    );
};